<div *ngIf="open" class="fixed inset-0 items-center justify-center p-5 flex overflow-y-auto modal z-99999"
  id="eventModal">
  <!-- Backdrop -->
  <div class="modal-close-btn fixed inset-0 h-full w-full bg-gray-400/50 backdrop-blur-[1px]"
    (click)="closeOnBackdrop ? onBackdrop() : null">
  </div>

  <!-- Dialog -->
  <div class="modal-dialog modal-dialog-scrollable no-scrollbar relative flex w-full" [ngClass]="dialogSizeClass"
    (click)="$event.stopPropagation()">
    <div
      class="modal-content custom-scrollbar flex w-full max-h-[90vh] flex-col rounded-3xl bg-white p-6 dark:bg-gray-900 lg:p-8">

      <!-- Header -->
      <div class="modal-header flex items-center justify-between">
        <ng-content select="[modal-header]"></ng-content>
        <ng-container *ngIf="!hasCustomHeader">
          <p class="font-semibold text-gray-800 modal-title text-theme-xl dark:text-white/90 lg:text-lg">
            {{ title }}
          </p>
          <button type="button" class="modal-close text-xl" (click)="close.emit()">✕</button>
        </ng-container>
      </div>

      <!-- Body -->
      <div class="mt-4 modal-body min-h-0 flex-1 overflow-y-auto" [class.flex]="fillBody" [class.flex-col]="fillBody">
        <ng-container *ngIf="bodyComponent; else projectedBody">
          <ng-template [ngComponentOutlet]="bodyComponent" [ngComponentOutletInputs]="bodyInputs" #dynHost>
          </ng-template>
        </ng-container>

        <ng-template #projectedBody>
          <ng-content select="[modal-body]"></ng-content>
        </ng-template>
      </div>

      <!-- Footer -->
      <div class="flex items-center gap-3 mt-6 modal-footer sm:justify-end flex-shrink-0">
        <ng-content select="[modal-footer]"></ng-content>
        <ng-container *ngIf="!hasCustomFooter">
          <button type="button"
            class="btn btn-secondary flex rounded-lg bg-gray-100 px-4 py-2.5 text-sm font-medium dark:bg-gray-800"
            (click)="close.emit()">
            Cancelar
          </button>
          <button type="button"
            class="btn btn-primary inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-70"
            [disabled]="isSaving" [attr.aria-busy]="isSaving" (click)="onConfirmClick()">
            <ng-container *ngIf="isSaving; else confirmText">
              <svg class="size-4 animate-spin text-white" viewBox="0 0 24 24" fill="none">
                <circle class="opacity-30" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                <path class="opacity-90" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              Guardando...
            </ng-container>
            <ng-template #confirmText>
              {{ confirmButtonText }}
            </ng-template>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
